import axios from 'axios'
import { getQueryString } from '@/utils'

// create an axios instance
const request = axios.create({
  baseURL: import.meta.env.VITE_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000, // request timeout
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  },
  paramsSerializer(params) {
    const queryString = getQueryString()
    return queryString
  }
})

// request interceptor
request.interceptors.request.use(
  config => {
    // do something before request is sent
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
request.interceptors.response.use(
  response => {
    const data = response?.data ?? {}
    const svflag = data?.svflag ?? -1
    const msg = data?.msg ?? 'Error'
    if (svflag !== 0) {
      window.layer.msg(msg)
      return Promise.reject(new Error(msg))
    }
    return data
  },
  error => {
    console.log('err' + error) // for debug
    window.layer.msg(error.message)
    return Promise.reject(error)
  }
)

export default request
